import { type FormDefinition, OTHER_CHOICE_ID } from "@fobu/schema";
import { indexForm, parseUrlValue } from "@fobu/engine";

/**
 * URL-Parameter → Hidden Fields (nach Name) und Vorbelegung (nach Feld-Key).
 * Hidden Fields haben Vorrang, falls ein Name doppelt vorkommt.
 */
export function readUrlParams(def: FormDefinition, search: string): { hidden: Record<string, string>; answers: Record<string, unknown> } {
  const params = new URLSearchParams(search);
  const hiddenNames = new Set(def.hiddenFields.map((h) => h.name));
  const idx = indexForm(def);
  const hidden: Record<string, string> = {};
  const answers: Record<string, unknown> = {};
  for (const [name, value] of params) {
    if (hiddenNames.has(name)) hidden[name] = value;
    else {
      const field = idx.fieldByKey.get(name);
      if (!field) continue;
      const v = parseUrlValue(field, value);
      if (v !== undefined && v !== OTHER_CHOICE_ID) answers[field.id] = v;
    }
  }
  return { hidden, answers };
}

/** Feld, dessen Antwort aus einem Antwortknopf der Einladungsmail stammt (`fbm=<key>`) – nur wenn sie übernommen wurde. */
export function mailFieldId(def: FormDefinition, search: string, answers: Record<string, unknown>): string | undefined {
  const key = new URLSearchParams(search).get("fbm");
  const id = key ? indexForm(def).fieldByKey.get(key)?.id : undefined;
  return id && answers[id] !== undefined ? id : undefined;
}
